import axios from "axios";
import useAction from "../../system/useAction";
import { Dispatch, SetStateAction, useState } from "react";
import Sidebar from "../../Components/Sidebar/Sidebar";
import { LeasmanVehicle, UserRole, Vehicle } from "../../system/Domain";
import SidebarGroup from "../../Components/Sidebar/SidebarGroup";
import SidebarButton from "../../Components/Sidebar/SidebarButton";
import LeasmanSyncTile from "./LeasmanSyncTile";
import CorrectPlateNumberDialog from "./CorrectPlateNumberDialog";

export interface Props {
	vehicle: Vehicle
	setVehicle: Dispatch<SetStateAction<Vehicle | undefined>>
	leasmanVehicle?: LeasmanVehicle
}

const BaseDataSidebar = ({ vehicle, setVehicle, leasmanVehicle }: Props) => {
	const [isCorrectingPlateNumber, setIsCorrectingPlateNumber] = useState(false);

	const [synchronize, isSynchronizing] = useAction(async () => {
		axios.post(`/api/vehicles/${vehicle.id}/synchronize`, {});
	});

	const [setLeasmanVehicle, isSettingLeasmanVehicle] = useAction(async () => {
		if (!leasmanVehicle) {
			return;
		}

		const { data } = await axios.put(`/api/vehicles/${vehicle.id}/leasman`, {
			leasmanVehicleId: leasmanVehicle.id,
		});

		setVehicle(data);
	});

	if (!vehicle) {
		return null;
	}

	return (
		<Sidebar>
			<SidebarGroup>
				{leasmanVehicle && leasmanVehicle.id !== vehicle.remarketing.leasmanVehicleId && (
					<SidebarButton
						label="Leasman Vertrag zuweisen"
						color="primary"
						roles={[UserRole.AldManager]}
						onClick={setLeasmanVehicle}
						disabled={isSettingLeasmanVehicle}
					/>
				)}
			</SidebarGroup>
			<SidebarGroup>
				<SidebarButton
					label="Synchronisieren"
					roles={[UserRole.AldUser, UserRole.AldManager, UserRole.SalesAdmin, UserRole.SalesBackoffice]}
					disabled={isSynchronizing}
					onClick={synchronize}
				/>
				<LeasmanSyncTile vehicle={vehicle} />
			</SidebarGroup>
			<SidebarGroup>
				<SidebarButton
					label="Kennzeichen korrigieren"
					roles={[UserRole.AldUser]}
					onClick={() => setIsCorrectingPlateNumber(true)}
				/>
			</SidebarGroup>
			<CorrectPlateNumberDialog
				open={isCorrectingPlateNumber}
				vehicle={vehicle}
				leasmanVehicle={leasmanVehicle}
				onClose={() => setIsCorrectingPlateNumber(false)}
				onSaved={(updatedVehicle) => {
					setVehicle(updatedVehicle);
					setIsCorrectingPlateNumber(false);
				}}
			/>
		</Sidebar>
	);
};

export default BaseDataSidebar;
